__turbopack_context__.v({
  "className": "montserrat_9152c979-module__42eAOG__className",
  "variable": "montserrat_9152c979-module__42eAOG__variable",
});
